<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list.list-data.reorder-entries.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="closeModal()" [disabled]="isLoading"></button>
</div>
<div class="modal-body">
	<form name="form" #f="ngForm">
		<div class="mb-3 row">
			<div class="col">
				<span jhiTranslate="germplasm-list.list-data.reorder-entries.description"></span>
			</div>
		</div>
		<div class="mb-3 row">
			<div class="col">
				<input class="ms-3" type="radio" data-test="atTheBeginningOption" id="atTheBeginning" name="atTheBeginning" [value]="Position.START" [(ngModel)]="this.position"/>
				<label class="ms-1" for="atTheBeginning" jhiTranslate="germplasm-list.list-data.reorder-entries.position-labels.beginning"></label>
			</div>
		</div>
		<div class="mb-3 row">
			<div class="col">
				<input class="ms-3" type="radio" data-test="atTheEndOption" id="atTheEnd" name="atTheEnd" [value]="Position.END" [(ngModel)]="this.position"/>
				<label class="ms-1" for="atTheEnd" jhiTranslate="germplasm-list.list-data.reorder-entries.position-labels.end"></label>
			</div>
		</div>
		<div class="mb-3 row">
			<div class="col d-flex align-items-center">
				<input class="ms-3" type="radio" data-test="fixedPositionOption" id="fixedPosition" name="fixedPosition" [value]="Position.FIXED" [(ngModel)]="this.position"/>
				<label class="ms-1" for="fixedPosition" jhiTranslate="germplasm-list.list-data.reorder-entries.position-labels.fixed"></label>
				<input [disabled]="this.position !== Position.FIXED" type="text" class="ms-2 form-control" id="fixedPositionNumber" data-test="fixedPositionNumberInput"
					   name="fixedPositionNumber" pattern="^[1-9][0-9]*$" [(ngModel)]="this.fixedPosition" required/>
			</div>
		</div>
	</form>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="reorder()" [disabled]="!isFormValid(f)" class="btn btn-primary" data-test="submitReorderEntriesButton">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-bars"></span>&nbsp;<span jhiTranslate="germplasm-list.list-data.reorder-entries.reorder-action"></span>
	</button>
</div>
